export const ShowConfigure = 'tech-demo-1/settings/SHOW_CONFIGURE'
export const HideConfigure = 'tech-demo-1/settings/HIDE_CONFIGURE'
export const SetCurrentTableOptions =
  'tech-demo-1/settings/SET_CURRENT_TABLE_OPTIONS'
export const ClearCurrentTableOptions =
  'tech-demo-1/settings/CLEAR_CURRENT_TABLE_OPTIONS'

export default {
  ShowConfigure,
  HideConfigure,
  SetCurrentTableOptions,
  ClearCurrentTableOptions
}



// WEBPACK FOOTER //
// ./src/store/settings/action-type.js